import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}
const FeaturesTiles = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'features-tiles section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner pt-0',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
  );

  const sectionHeader = {
    title: 'Funcionalidades',
    paragraph: 'Conheça as funcionalidades do Sistema CobreMais+'
  };

  return (
    <section
      {...props}
      className={outerClasses}
      id="funcionalidades"
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={tilesClasses}>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16" style={{padding: 25}}>
                    <Image
                      src={require('./../../assets/images/sms.svg')}
                      alt="Features tile icon 01"
                      width={50}
                      height={50} 
                      style={{width: 50, height: 50}}
                    />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Cobranças por SMS
                  </h4>
                  <p className="m-0 text-sm">
                    Envie mensagens de cobrança personalizados para seus clientes.
                  </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16" style={{padding: 25}}>
                    <Image
                      src={require('./../../assets/images/success.svg')}
                      alt="Features tile icon 02"
                      style={{width: 50, height: 50}}
                      width={50}
                      height={50} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Cobranças por E-mail
                  </h4>
                  <p className="m-0 text-sm">
                    Envie e-mail massivos para seus clientes com templates customizados.
                  </p>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16" style={{padding: 25}}>
                    <Image
                      src={require('./../../assets/images/phone-call.svg')}
                      alt="Features tile icon 03"
                      style={{width: 50, height: 50}}
                      width={50}
                      height={50} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Cobrança por Telefone
                  </h4>
                  <p className="m-0 text-sm">
                    Simplifique seu serviço de cobrança com o nosso de serviço de cobrança automática por telefone.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

FeaturesTiles.propTypes = propTypes;
FeaturesTiles.defaultProps = defaultProps;

export default FeaturesTiles;